export const sdkInfo = {
    host: 'npmjs.com',
    version: '12.4.3',
    name: '@kontent-ai/delivery-sdk'
};
//# sourceMappingURL=sdk-info.generated.js.map